/* =========================================================
   TISBELLE-STYLE SHOPIFY SCROLL ANIMATIONS
   ========================================================= */

(function () {
  'use strict';

  /* -------------------------------------------------------
     SETTINGS
     ------------------------------------------------------- */

  const revealSelector = [
    '#MainContent > .shopify-section',
    '#MainContent > section',
    '#MainContent > div.shopify-section',
    '.tsb-reveal'
  ].join(',');

  const staggerSelectors = [
    '.product-grid',
    '.collection-list',
    '.multicolumn-list',
    '.blog__posts',
    '.tsb-stagger'
  ];

  /* -------------------------------------------------------
     REDUCED MOTION
     ------------------------------------------------------- */

  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  if (prefersReducedMotion) {
    document
      .querySelectorAll(revealSelector)
      .forEach(function (element) {
        element.classList.add('tsb-visible');
      });

    return;
  }

  /* -------------------------------------------------------
     INTERSECTION OBSERVER
     ------------------------------------------------------- */

  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.05
  };

  const revealObserver = new IntersectionObserver(
    function (entries, observer) {

      entries.forEach(function (entry) {

        if (!entry.isIntersecting) return;

        entry.target.classList.add('tsb-visible');

        /*
         * Stop observing after the first reveal.
         * This prevents the animation from repeatedly
         * playing every time the user scrolls past it.
         */
        observer.unobserve(entry.target);

      });

    },
    observerOptions
  );

  /* -------------------------------------------------------
     INITIALIZE SECTION REVEALS
     ------------------------------------------------------- */

  function initializeReveals() {

    document
      .querySelectorAll(revealSelector)
      .forEach(function (element) {

        /*
         * Don't animate extremely small elements.
         */
        if (element.offsetHeight < 50) return;

        element.classList.add('tsb-reveal');

        revealObserver.observe(element);

      });
  }

  /* -------------------------------------------------------
     STAGGER PRODUCT / CONTENT GRIDS
     ------------------------------------------------------- */

  function initializeStagger() {

    staggerSelectors.forEach(function (selector) {

      document
        .querySelectorAll(selector)
        .forEach(function (element) {

          if (
            element.classList.contains('tsb-stagger')
          ) {
            return;
          }

          element.classList.add('tsb-stagger');

          revealObserver.observe(element);

        });

    });
  }

  /* -------------------------------------------------------
     PRODUCT CARD CLASS
     ------------------------------------------------------- */

  function initializeProductCards() {

    const cards = document.querySelectorAll(
      '.card-wrapper, .product-card-wrapper, .card--product'
    );

    cards.forEach(function (card) {

      card.classList.add('tsb-product-card');

    });

  }

  /* -------------------------------------------------------
     RUN
     ------------------------------------------------------- */

  function initializeAnimations() {

    initializeReveals();
    initializeStagger();
    initializeProductCards();

  }

  /* -------------------------------------------------------
     INITIAL PAGE LOAD
     ------------------------------------------------------- */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initializeAnimations
    );

  } else {

    initializeAnimations();

  }

  /* -------------------------------------------------------
     SHOPIFY SECTION RELOAD SUPPORT
     ------------------------------------------------------- */

  document.addEventListener(
    'shopify:section:load',
    function () {

      setTimeout(function () {
        initializeAnimations();
      }, 100);

    }
  );

})();

